import {
  redirect,
  useLoaderData,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import "./styles.css";
import { externalRedirect } from "../page-redirect";
import GenericErrorDisplay from "../generic-error";
import { AxiosError } from "axios";
import ResourceDisplay from "../../components/resource-display";
import ButtonPrimary from "../../components/button-primary/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ResourceService from "../../service/resource";
import LinktreeService from "../../service/linktree";

const resourceKeys = {
  image: "not-found-image",
};

export async function loader({ request }) {
  try {
    const url = new URL(request.url);
    const id = url.href.substring(url.origin.length + 1);
    const entry = await new LinktreeService().read.byId(id);
    if (entry !== undefined) {
      if (entry.local) return redirect("/" + entry.ref);
      else return externalRedirect(entry.ref);
    }
  } catch (e) {
    if (e instanceof AxiosError && e.response && e.response.status === 404) {
      return await new ResourceService().read.byIds(
        Object.values(resourceKeys)
      );
    }
    throw e;
  }
}

export function Component() {
  const resources = useLoaderData();
  const navigate = useNavigate();

  return (
    <div id="not-found">
      <div className="text-container">
        <h1>Ooops...</h1>
        <h4>Pagina nu a fost găsită</h4>
        <ButtonPrimary onClick={() => navigate(-1)} className="button">
          <FontAwesomeIcon icon={faChevronLeft} />
          Înapoi
        </ButtonPrimary>
      </div>
      <ResourceDisplay
        resource={resources[resourceKeys.image]}
        className="image-container"
      />
    </div>
  );
}
Component.displayName = "page-not-found";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-not-found-error";
